const TWO_CJK_CHAR_RE = /^[\u4e00-\u9fa5]{2}$/;

/** Ant Design 默认会在两字中文按钮间插入空格（取 消），用零宽字符打断匹配 */
export function compactButtonText(text: string) {
  return TWO_CJK_CHAR_RE.test(text) ? `${text[0]}\u200b${text[1]}` : text;
}
